import React from 'react';

export default function StudentSupport() {
  return (
    <div className="student-support">
      <h2>Help and Support</h2>
      <p>
        Welcome to the Help and Support section. Here you can find information about how to use our platform,
        troubleshoot common issues, and get in touch with our support team.
      </p>
      <p>
        If you're experiencing technical difficulties, please try clearing your browser cache and cookies,
        or try accessing the platform from a different browser or device.
      </p>
      <p>
        For any questions or concerns about your classes, please reach out to your teacher directly
        through the messaging system on our platform.
      </p>
      <p>
        If you need further assistance, please don't hesitate to contact our support team at:
      </p>
      <p className="support-email">
        <strong>support@akademix.com</strong>
      </p>
      <p>
        Our support team is available Monday through Friday, 9:00 AM to 9:00 PM IST.
        We typically respond to all inquiries within 24 hours.
      </p>
    </div>
  );
}